import { signOut } from 'aws-amplify/auth';
import { RESET } from 'jotai/utils';
import config from '~/config';
import { g } from '~/globals';
import { authStateAtom } from '~/state/auth';

export default function logoutAction() {
  // We can not just clear everything as we don't want to loose the kiosk mode
  g.reg.jotaiStore.set(authStateAtom, RESET);

  // Remove all data that is present cached
  g.reg.queryClient.clear();

  // Sign out the cognito user
  if (config.useCognito) {
    // This is a quick hack because we are in a time pickle.
    // The function should be rewritten to be async
    signOut().finally(() => {
      // Clear localstorage: We can't just do this, as the kiosks demand an item to be set
      // TODO: Figure out if it is reasonable not to do anything else
      // localStorage.clear();

      // Reset session storage
      sessionStorage.clear();
      window.location.href = '/';
    });
  } else {
    // Clear localstorage: We can't just do this, as the kiosks demand an item to be set
    // TODO: Figure out if it is reasonable not to do anything else
    // localStorage.clear();

    // Reset sessions storage
    sessionStorage.clear();
    window.location.href = '/';
  }
}
